export const AbortMessageModal: string = 'AbortMessageModal';
